import { put, call, takeLatest } from 'redux-saga/effects';
import types from './actionTypes';
import * as dealersActions from './actions';
import apiCall from '../../helpers/axiosApiCallWrapper';
import toastr from 'toastr';

function* syncDealersSaga({ params }) {
  try {
    const { dealers } = yield call(apiCall, 'POST', `/getRCSDealers`, params);

    yield put(dealersActions.syncDealersSuccess(dealers));
  } catch (error) {
    yield put(dealersActions.syncDealersFailure(error));
    toastr.error('Error syncing dealers');
  }
}

function* dealerSaga() {
  yield takeLatest(types.SYNC_DEALERS.REQUEST, syncDealersSaga);
}

export default dealerSaga;
